var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('div',[_c('div',[_vm._v("Welcome to Connect")]),_c('button',{staticClass:"btn btn-secondary my-2 my-sm-0",staticStyle:{"float":"right"},on:{"click":_vm.login}},[_vm._v(" Log In ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }